module.exports = __webpack_public_path__ + "img/new-rank-bg.3e0ba38a.png";